import { combineReducers } from 'redux';

import byId from './byId';

/**
 * @typedef {{
 *   byId : import('./byId').State
 * }} NotificationDataConfigurationReducer
 */

export default combineReducers({
  byId,
});
